import { Fragment, ReactElement } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { evaluationItems } from './evaluationItems'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
interface TitleProps {
  isLast?: boolean;
}
export const EvaluationPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Evaluation"
        subTitleText="社外評価"
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <OfficerList>
        {evaluationItems.map(({ title, imgPath, url, profile }, index) => (
          <Fragment key={imgPath}>
            {index > 0 && <Spacer h={{ sp: 30, pc: 40 }} />}
            <OfficerItem>
              <PersonalInfo>
                <Title isLast={index === evaluationItems.length - 1}>{title}</Title>
                <a href={url} target="_blank" rel="noopener noreferrer" className="pdf_after">
                  <Images src={imgPath} />
                </a>
              </PersonalInfo>
              <Profile>
                {profile.map(({ date, content }, index, array) => (
                  <Fragment key={date}>
                    <ProfileItem>
                      <p>{date}</p>
                      <p>{content}</p>
                    </ProfileItem>
                    {index < array.length - 1 && (
                      <Spacer h={{ sp: 10, pc: 12 }} />
                    )}
                  </Fragment>
                ))}
              </Profile>
            </OfficerItem>
            <SpacerBorder h={{ sp: 30, pc: 40 }} />
          </Fragment>
        ))}
      </OfficerList>
    </Layout>
  )
}

EvaluationPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主、投資家向け情報', path: '/ir' },
    { name: '社外評価', path: '' },
  ]

  return (
    <>
      <Head
        title="社外評価"
        description="トライアルホールディングスのIRメール配信のお申し込み方法、停止方法について掲載しています。"
        ogp={{ url: 'ir/evaluation' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const OfficerList = styled.ul`
  width: 100%;
`

const OfficerItem = styled.div`
  display: flex;
  gap: 37px;
  @media screen and (max-width: 1047px) {
    gap: 20px;
  }
  @media screen and (max-width: 500px) {
    flex-direction: column;
  }
`

const SpacerBorder = styled(Spacer)`
  :not(:last-of-type) {
    border-bottom: 1px solid ${theme.colors.grey};
  }
`

const PersonalInfo = styled.div`
  width: 210px;
  text-align: center;

  @media screen and (max-width: 1047px) {
    width: 180px;
  }
  @media screen and (max-width: 500px) {
    width: 100%;
  }

  &:hover {
    a {
      text-decoration: underline;
      color: ${theme.colors.hoverLightBlue};
    }

    .pdf_after:after {
      background: url('/images/external-link-hoverblue.svg') no-repeat;
    }
  }

  .pdf_after {
    &:after {
      content: '';
      background: url('/images/external-link-black.svg') no-repeat;
      width: 12px;
      height: 12px;
      margin-left: 8px;
      display: inline-block;
    }
  }
`

const Title = styled.p<TitleProps>`
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 1.8px;
  font-weight: bold;
  ${({ isLast }) =>
    isLast &&
    `
      font-size: 17px;
    `}
  @media screen and (max-width: 500px) {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 1.6px;
  }
`

const Images = styled.img`
  width: 130px;
  margin-top: 20px;
  @media screen and (max-width: 1047px) {
    width: 130px;
  }
  @media screen and (max-width: 500px) {
    width: 60%;
  }
`

const Profile = styled.div`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 1.6px;
  flex: 1;
  width: calc(100% - 247px);

  @media screen and (max-width: 1047px) {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 1.4px;
    width: calc(100% - 200px);
  }
  @media screen and (max-width: 500px) {
    width: 100%;
    margin-top: 15px;
  }
`

const ProfileItem = styled.li`
  // display: flex;
  // gap: 20px;

  p:first-child {
    font-weight: bold;
  }

  p:last-child {
    margin-top: 15px;
  }

  @media screen and (max-width: 1047px) {
    // gap: 10px;

    // p::first-child {
    //   width: 90px;
    // }
  }
`
